import { google_analytics_id } from '../../../constants';
import { GoogleTracker } from '@buzzfeed/third-party-analytics';

let trackingInstance;

if (!google_analytics_id) {
  console.error(
    'Google Analytics ID is not set - will not fire any GA events.'
  );
}

const ga = () => {
  if (!trackingInstance) {
    trackingInstance = new GoogleTracker({ google_analytics_id });
  }
  return trackingInstance;
};

export async function trackGooglePageview() {
  const tracker = await ga();
  tracker.sendPageview({ dimension1: 'bf_user_profile_ui' });
}
